"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceCollectionProcessor = void 0;
const ResourceItem_1 = require("./ResourceItem");
class ResourceCollectionProcessor {
    processResults(response) {
        return (response.results ?? []).map(result => new ResourceItem_1.ResourceItem(result));
    }
}
exports.ResourceCollectionProcessor = ResourceCollectionProcessor;
